<template>
  <div
    class="contenedor d-flex flex-column justify-content-center align-items-center spinner-container"
  >
    <div class="spinner-border loading-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>